export function isHttpError(error) {
    if (!(error instanceof Error)) {
        return false;
    }
    return error.isWixHttpError === true;
}
export function extractHttpErrorDetails(error) {
    return {
        requestId: error.requestId,
        config: extractHttpErrorConfig(error),
        response: extractHttpErrorResponse(error),
    };
}
function extractHttpErrorConfig(error) {
    const { url, method, params, data } = error.config ?? {};
    const config = {
        url,
        method,
        ...(params && { params: JSON.stringify(params) }),
        ...(data && { data: JSON.stringify(data) }),
    };
    return config;
}
function extractHttpErrorResponse(error) {
    const { status, statusText, data } = error.response ?? {};
    const response = {
        status,
        statusText,
        ...(data && { data: JSON.stringify(data) }),
    };
    return response;
}
export function getSerializableHttpError(error) {
    const { status, statusText, data } = error.response ?? {};
    const { url, method, params, data: configData } = error.config ?? {};
    const response = {
        status,
        statusText,
        data,
    };
    const config = {
        url,
        method,
        params,
        data: configData,
    };
    return {
        code: error.code,
        config,
        response,
        isWixHttpError: error.isWixHttpError,
        requestId: error.requestId,
    };
}
//# sourceMappingURL=http-error.js.map